<template>
  <div class="UpdateHistorys">
    <el-container>
      <el-header
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h1>游戏更新记录</h1>
        <el-button
          type="primary"
          @click="openDialog"
          size="small"
          
        >
          添加更新记录
        </el-button>
      </el-header>
      <el-main>
        <!-- 添加更新记录 Dialog -->
        <el-dialog
          title="添加游戏更新记录"
          v-model="showDialog"
          :width="isMobile ? '90%' : '30%'"
          @close="resetDialog"
          :close-on-click-modal="false"
        >
          <el-form :model="formData" label-width="100px">
            <el-form-item label="选择游戏">
              <el-select
                v-model="formData.gameid"
                multiple
                placeholder="请选择要添加的游戏"
                filterable
                clearable
              >
                <el-option
                  v-for="game in games"
                  :key="game.gameid"
                  :label="game.title"
                  :value="game.gameid"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="showDialog = false">取消</el-button>
            <el-button type="primary" @click="submitUpdate">提交</el-button>
          </template>
        </el-dialog>

        <div v-if="logs.length === 0 && !loading" class="no-logs">
          暂无更新日志
        </div>
        <div v-else>
          <div class="log-list">
            <div
              v-for="(log, index) in logs"
              :key="log.id"
              :class="[
                'log-item',
                { latest: index === 0 && currentPage === 1 },
              ]"
            >
              <div class="main-row-flex">
                <!-- 左侧主信息 -->
                <div class="main-info">
                  <div class="data-item">
                    <!-- 永远显示的字段 -->
                    <div class="data-row">
                      <strong>游戏名称:</strong>
                      <span class="data-text">{{ log.title }}</span>
                    </div>
                    <div class="data-row">
                      <strong>游戏ID:</strong>
                      <span class="data-text">{{ log.gameid }}</span>
                    </div>
                    <!-- 有值才显示的字段 -->
                    <div class="data-row" v-if="log.api_time">
                      <strong>当前更新时间:</strong>
                      <span class="data-text">{{ log.api_time }}</span>
                    </div>
                    <div class="data-row" v-if="log.db_time">
                      <strong>上次更新时间:</strong>
                      <span class="data-text">{{ log.db_time }}</span>
                    </div>
                    <div class="data-row" v-if="log.api_buildid">
                      <strong>最新游戏版本号:</strong>
                      <el-tag
                        type="info"
                        size="small"
                        effect="dark"
                        class="version-tag latest-version"
                      >
                        {{ log.api_buildid }}
                      </el-tag>
                    </div>
                    <div class="data-row" v-if="log.db_buildid">
                      <strong>现有游戏版本号:</strong>
                      <el-tag
                        size="small"
                        effect="plain"
                        class="version-tag old-version"
                      >
                        {{ log.db_buildid }}
                      </el-tag>
                    </div>
                    <!-- 永远显示状态 -->
                    <div class="data-row">
                      <strong>该游戏更新状态:</strong>
                      <el-tag
                        :type="typeTagInfo(log.types).type"
                        effect="dark"
                        size="small"
                      >
                        {{ typeTagInfo(log.types).label }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <!-- 右侧 depots 列表或提示 -->
                <div
                  class="depots-info"
                  v-if="
  owner === '0' &&
  log.depots &&
  visibleDepots(log).length > 0
"
                >
                  <div
  class="depot-item-flex"
  v-for="(depot, didx) in visibleDepots(log)"
  :key="didx"
>
                    <img
                      class="depot-img"
                      :src="`https://cdn.akamai.steamstatic.com/steam/apps/${depot.depot}/header.jpg`"
                      :alt="`depot ${depot.depot}`"
                      loading="lazy"
                      @error="(event) => (event.target.style.display = 'none')"
                    />
                    <div class="depot-info">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                        "
                      >
                        <div><strong>DepotID:</strong> {{ depot.depot }}</div>
                        <el-button
                          class="add-dlc-btn"
                          size="small"
                          type="primary"
                          @click="addDepotToDLC(log.gameid, depot)"
                          plain
                        >
                          添加DLC进库
                        </el-button>
                      </div>
                      <div><strong>添加时间:</strong> {{ depot.addTime }}</div>
                      <div><strong>名称:</strong> {{ depot.name || "-" }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 显示实际更新已完成的时间 -->
              <div class="log-footer">
                <div class="update-id">
                  <strong>{{ Number(log.types) === 1 ? "更新完成时间:" : "完成/失败时间:" }}</strong>
                  {{ log.up_complete_time || log.up_fail_time || "-" }}
                </div>
                <div class="update-id" v-if="log.reson">
                  <strong>失败原因:</strong>
                  {{ log.reson }}
                </div>
                <el-button
                  v-if="owner === '0'"
                  type="danger"
                  text
                  @click="confirmDelete(log)"
                >
                  <el-icon style="margin-right: 6px"><DeleteIcon /></el-icon>
                  删除
                </el-button>
              </div>
            </div>
          </div>

          <!-- 分页控件 -->
          <el-pagination
            v-if="total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin-top: 20px; text-align: center"
          ></el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import axios from "../axios";
import dayjs from "dayjs";
import { ElMessage, ElMessageBox } from "@/plugins/tdesignElementAdapter";
import { DeleteIcon } from "tdesign-icons-vue-next";

const store = useStore();
const owner = computed(() => store.state.user.owner ?? "0");

const logs = ref([]);
const currentPage = ref(1);
const pageSize = ref(20);
const total = ref(0);
const loading = ref(false);

const showDialog = ref(false);
const formData = ref({
  gameid: [],
});
const games = ref([]);

const isMobile = ref(window.innerWidth <= 768);
window.addEventListener("resize", () => {
  isMobile.value = window.innerWidth <= 768;
});

// 获取主列表
async function fetchLogs() {
  try {
    loading.value = true;
    const token = localStorage.getItem("user-token");
    const response = await axios.post("/index.php?action=checkUpdateHistorys", {
      token,
      page: currentPage.value,
    });
    const res = response.data;
    if (res && res.code === 200 && Array.isArray(res.data)) {
      logs.value = res.data;
      total.value = res.total || 0;
    } else {
      logs.value = [];
      total.value = 0;
    }
  } catch (error) {
    logs.value = [];
    total.value = 0;
  } finally {
    loading.value = false;
  }
}

// 获取游戏列表
async function fetchGames() {
  try {
    const token = localStorage.getItem("user-token");
    const response = await axios.post("/index.php?action=getGames_make", {
      token,
    });
    games.value = Array.isArray(response.data.games) ? response.data.games : [];
  } catch (e) {
    ElMessage.error("获取游戏列表失败");
  }
}

async function deleteLogById(id, alsoDeleteDepots = 0) {
  const token = localStorage.getItem("user-token");
  try {
    const res = await axios.post("/index.php?action=deleteUpdateHistory", {
      token,
      id,
      also_delete_depots: alsoDeleteDepots, // 0 仅删除日志；1 连同该游戏的 depots 一起删除
    });
    if (res.data && (res.data.code === 200 || res.data.success)) {
      ElMessage.success("删除成功");
      // 如果当前页删到没有数据了，回到上一页
      if (logs.value.length === 1 && currentPage.value > 1) {
        currentPage.value -= 1;
      }
      fetchLogs();
    } else {
      ElMessage.error(res.data?.message || "删除失败");
    }
  } catch (e) {
    ElMessage.error("删除请求失败");
  }
}

function confirmDelete(log) {
  ElMessageBox.confirm(
    `确定删除这条更新记录吗？\n${log.title} / ${log.gameid}`,
    "删除确认",
    {
      confirmButtonText: "删除",
      cancelButtonText: "取消",
      type: "warning",
      autofocus: false,
      closeOnClickModal: false,
    }
  )
    .then(() => deleteLogById(log.id, 0)) // 也可以传 1 同时删除 depots
    .catch(() => {});
}

// 打开 Dialog 并拉取游戏列表
function openDialog() {
  showDialog.value = true;
  fetchGames();
}

// 关闭重置
function resetDialog() {
  formData.value.gameid = [];
}

// 提交
async function submitUpdate() {
  if (!formData.value.gameid.length) {
    ElMessage.warning("请先选择游戏");
    return;
  }
  try {
    const token = localStorage.getItem("user-token");
    const gameids = formData.value.gameid.join(",");
    const response = await axios.post(
      "/index.php?action=addUpdateGameRecords",
      {
        token,
        gameid: gameids,
      }
    );
    if (response.data.success) {
      ElMessage.success("添加成功");
      showDialog.value = false;
      resetDialog();
      fetchLogs();
    } else {
      ElMessage.error(response.data.message || "添加失败");
    }
  } catch (e) {
    ElMessage.error("提交失败");
  }
}

function visibleDepots(log) {
  return Array.isArray(log?.depots)
    // 接口返回的 depots 已经是 dlc_depots 中不存在的项。
    // Steam 接口未查到名称时 name 会为空，不能因此隐藏整个 depot。
    ? log.depots.filter((d) => !String(d.depot).startsWith("2289"))
    : [];
}

async function addDepotToDLC(gameid, depot) {
  const token = localStorage.getItem("user-token");
  const addTime = dayjs(depot.addTime)
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const payload = {
    gameid: String(gameid),
    depot: String(depot.depot),
    addTime,
    types: 0,
  };
  try {
    const res = await axios.post("/index.php?action=addNewGameDLC", {
      token,
      depot: JSON.stringify(payload),
    });
    if (res.data.success || res.data.code === 200) {
      ElMessage.success("DLC添加成功");
      fetchLogs();
    } else {
      ElMessage.error(res.data.message || "添加失败");
    }
  } catch (err) {
    ElMessage.error("请求失败");
  }
}

function handleSizeChange(newSize) {
  pageSize.value = newSize;
  currentPage.value = 1;
  fetchLogs();
}
function handleCurrentChange(newPage) {
  currentPage.value = newPage;
  fetchLogs();
}

function typeTagInfo(types) {
  switch (Number(types)) {
    case 0:
      return { label: "未更新", type: "warning" };
    case 1:
      return { label: "已更新", type: "success" };
    case 2:
      return { label: "云授权添加失败", type: "danger" };
    case 3:
      return { label: "内容仍处于加密状态", type: "danger" };
    case 4:
      return { label: "内容配置文件不可用", type: "danger" };
    case 5:
      return { label: "规则未识别/无有效 Depot", type: "danger" };
    default:
      return { label: "未知错误", type: "info" };
  }
}

onMounted(fetchLogs);
</script>

<style scoped>
ul,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}
.log-list li,
.data-item,
ul li,
ol li {
  list-style: none !important;
  margin: 0;
  padding: 0;
}

.UpdateHistorys {
  padding: 20px;
  font-family: "Helvetica Neue", Arial, sans-serif;
  background: #f5f7fa;
  min-height: 100vh;
  color: #333;
}

h1 {
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  color: #2c3e50;
}

.no-logs {
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 16px;
}

.log-list {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.log-item {
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  word-break: break-word;
  position: relative;
}

.main-row-flex {
  display: flex;
  flex-direction: row;
  gap: 36px;
  align-items: flex-start;
}

.main-info {
  min-width: 330px;
  flex-shrink: 0;
}
.depots-info {
  flex: 1;
  min-width: 220px;
  padding-left: 24px;
  border-left: 2px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.depot-item-flex {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background: #fafbfc;
  border: 1px solid #e4e8ee;
  border-radius: 7px;
  padding: 8px 16px;
  margin-bottom: 7px;
  font-size: 13px;
  color: #454d64;
  box-shadow: 0 0 2px #e6e9ef;
  gap: 16px;
  min-height: 64px;
}

.depot-img {
  height: 100%;
  width: auto;
  max-width: 120px;
  border-radius: 5px;
  box-shadow: 0 0 2px #e6e9ef;
  object-fit: cover;
  flex-shrink: 0;
  background: #f5f5f5;
  margin-right: 8px;
  display: block;
}

.depot-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.depots-empty {
  width: 100%;
  color: #bbb;
  text-align: center;
  font-size: 14px;
  padding: 20px 0 20px 0;
  letter-spacing: 1px;
  font-weight: 500;
}

.log-footer {
  display: flex;
  justify-content: space-between; /* 关键：与时间左右分散 */
  align-items: center;
  gap: 12px;
  border-top: 1px solid #eee;
  padding-top: 12px;
  margin-top: 12px;
}

/* 原来的 .update-id 有边框与上边距，这里交给 .log-footer 统一处理 */
.update-id {
  padding-top: 0;
  border-top: none;
  margin-top: 0;
}

.data-item {
  margin-bottom: 12px;
}
.data-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 5px;
  font-size: 14px;
  color: #444;
}
.data-row strong {
  width: 130px;
  flex-shrink: 0;
  color: #000000;
}
.data-text {
  flex-grow: 1;
  white-space: pre-wrap;
}
.version-tag {
  font-weight: 600;
  cursor: default;
}
hr {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 8px 0;
}
.version-tag.latest-version {
  font-weight: 600;
  cursor: default;
  color: #096dd9;
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
}
.version-tag.old-version {
  font-weight: 600;
  cursor: default;
  color: #999;
  text-decoration: line-through;
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}

@media (max-width: 768px) {
  .main-row-flex {
    flex-direction: column;
    gap: 0;
  }
  .depots-info {
    padding-left: 0;
    border-left: none;
    margin-top: 14px;
  }
  .main-info {
    min-width: 0;
  }
  .depot-item-flex {
    flex-direction: column;
    align-items: stretch;
    min-height: unset;
    padding: 8px 4px;
    gap: 8px;
  }
  .depot-img {
    width: 100%;
    max-width: 100%;
    height: auto;
    margin-right: 0;
    margin-bottom: 8px;
    border-radius: 7px 7px 0 0;
    object-fit: cover;
    display: block;
  }
}

.add-dlc-btn {
  margin-left: 8px;
  padding: 2px 10px;
  font-size: 13px;
  line-height: 18px;
  height: 22px;
  border-radius: 10px;
  background: #1677ff;
  color: #fff !important;
  border: none;
  transition: background 0.2s;
}
.add-dlc-btn:hover {
  background: #409eff;
  color: #fff;
}
@media (max-width: 768px) {
  .add-dlc-btn {
    margin-left: 4px;
    margin-top: 2px;
    width: auto;
    min-width: 80px;
  }
}
</style>

